import React from 'react';
import { Route, IndexRoute, Redirect, IndexRedirect } from 'react-router';
import { push } from 'react-router-redux';
import { UserAuthWrapper } from 'redux-auth-wrapper';

import {
  LoginPage,
  SspWebIndex,
  SspSettings,
  PubWebIndex,
  PubSettings,
  PubCnames,
  PubBilling,
  AdvSettings,
  AdvAccIndex,
  AdminPublisherIndex,
  AdminStatementIndex,
  AdminReportsPublisherIndex,
  AdminReportsAdvertiserIndex,
  AdminEmailAlertsIndex,
  AdminSalesRepsIndex,
  AdminAdsIndex,
  AdminCampaignsIndex,
  AdminAccountsIndex,
  AdminAdvertisersIndex,
  AdminFeedLogsIndex,
  AdminWebsiteIndex,
  AdminConnectionReportsIndex,
  Home,
  ErrorPage,
  Initializing,
  Loading,
  ForgotPassword,
  ResetPassword,
  AdvAccCardsIndex,
  AdvAccDashboard,
  AdvAccInvoicesIndex,
  AdvAccJobs,
  AdvAccEdit,
  AdvCampNew,
  AdvCampShow,
  AdvCampIndex,
  AdvCampWizard,
  AdvAdIndex,
  AdvAdNew,
  AdvAccPixel,
  AdvTermsOfService,
  PubWebDashboard,
  PubWebPixel,
  PubWebTemplates,
  PubWebSettings,
  PubWebEmailTemplate,
  PubTermsOfService,
} from './views';

import {
  AppContainer,
  SspContainer,
  SspWebsiteContainer,
  SspWebsitesContainer,
  PublisherContainer,
  PublisherWebsiteContainer,
  AdvertiserContainer,
  AdvertiserAccountContainer,
  AdminContainer,
} from './containers';

const LoadingWrapper = theme => {
  return React.createClass({
    render: () => {
      return <Initializing theme={theme} />;
    },
  });
};

const UserIsAuthenticated = UserAuthWrapper({
  authSelector: state => state.user.data,
  authenticatingSelector: state => state.user.loading,
  LoadingComponent: Initializing,
  failureRedirectPath: '/login',
  redirectAction: push,
  wrapperDisplayName: 'UserIsAuthenticated',
});

const UserIsAdmin = UserAuthWrapper({
  authSelector: state => state.user.data,
  authenticatingSelector: state => state.user.loading,
  LoadingComponent: LoadingWrapper('isAdmin'),
  redirectAction: push,
  failureRedirectPath: '/403',
  wrapperDisplayName: 'UserIsAdmin',
  predicate: user => user.isAdmin,
  allowRedirectBack: false,
});

const UserIsPublisher = UserAuthWrapper({
  authSelector: state => state.user.data,
  authenticatingSelector: state => state.user.loading,
  LoadingComponent: LoadingWrapper('isPublisher'),
  redirectAction: push,
  failureRedirectPath: '/403',
  wrapperDisplayName: 'UserIsPublisher',
  predicate: user => user.isPublisher,
  allowRedirectBack: false,
});

const UserIsSsp = UserAuthWrapper({
  authSelector: state => state.user.data,
  authenticatingSelector: state => state.user.loading,
  LoadingComponent: LoadingWrapper('isSsp'),
  redirectAction: push,
  failureRedirectPath: '/403',
  wrapperDisplayName: 'UserIsSsp',
  predicate: user => user.isSsp,
  allowRedirectBack: false,
});

const UserIsAdvertiser = UserAuthWrapper({
  authSelector: state => state.user.data,
  authenticatingSelector: state => state.user.loading,
  LoadingComponent: LoadingWrapper('isAdvertiser'),
  redirectAction: push,
  failureRedirectPath: '/403',
  wrapperDisplayName: 'UserIsAdvertiser',
  predicate: user => user.isAdvertiser,
  allowRedirectBack: false,
});

const UserIsNotCustomDash = UserAuthWrapper({
  authSelector: state => state.user.data,
  authenticatingSelector: state => state.user.loading,
  LoadingComponent: LoadingWrapper('isCustomDash'),
  redirectAction: push,
  failureRedirectPath: '/404',
  wrapperDisplayName: 'UserIsNotCustomDash',
  predicate: user => user.roles.filter(r => r === 'customdash').length === 0,
  allowRedirectBack: false,
});

export default (
  <Route name="Home" path="/" component={AppContainer}>
    <IndexRoute component={Home} />
    <Route path="login" component={Home} />
    <Route path="initializing" component={Loading} />
    <Route path="/403" component={ErrorPage} />
    <Route path="/404" component={ErrorPage} />
    <Route path="/500" component={ErrorPage} />

    <Route name="Ssp" breadcrumbIgnore path="ssp" component={SspContainer}>
      <IndexRoute component={LoginPage} />
      <Route path="login" component={LoginPage} />
      <Route path="password/:token/edit" component={ResetPassword} />
      <Route path="forgotpassword" component={ForgotPassword} />
      <Route name="User Settings" path="settings" component={UserIsAuthenticated(UserIsSsp(SspSettings))} />
      <Route name="Websites" path="websites" component={SspWebsitesContainer}>
        <IndexRoute breadcrumbIgnore component={UserIsAuthenticated(UserIsSsp(SspWebIndex))} />
        <Route
          name="Dashboard"
          breadcrumbName=":websiteName - :websitePage"
          path=":websiteSlug/:websitePage"
          component={UserIsAuthenticated(UserIsSsp(SspWebsiteContainer))}
        />
      </Route>
    </Route>

    <Route name="Publisher" breadcrumbIgnore path="publisher">
      <IndexRoute component={LoginPage} />
      <Route path="login" component={LoginPage} />
      <Route path="password/:token/edit" component={ResetPassword} />
      <Route path="forgotpassword" component={ForgotPassword} />
      <Route name="Publisher Home" path="home" breadcrumbIgnore component={UserIsAuthenticated(UserIsPublisher(PublisherContainer))}>
        <IndexRedirect to="websites" />
        <Route name="User Settings" path="settings" component={PubSettings} />
        {/* <Route name="CNAMEs" path="cnames" component={PubCnames} /> */}
        <Route name="Billing" path="billing" component={PubBilling} />
        <Route name="Websites" path="websites" breadcrumbName="Websites">
          <IndexRoute breadcrumbIgnore component={PubWebIndex} />
          <Route name="Website" path=":websiteName" breadcrumbName=":websiteName" component={PublisherWebsiteContainer}>
            <IndexRedirect to="dashboard" />
            <Route name="Dashboard" breadcrumbName="Dashboard" path="dashboard" component={PubWebDashboard} />
            {/* <Route name="Pixel" breadcrumbName="Pixel" path="pixel" component={PubWebPixel} /> */}
            <Route name="Website Settings" breadcrumbName="Website Settings" path="website_settings" component={PubWebSettings} />
            {/* <Route name="Templates" breadcrumbName="Templates" path="templates">
              <IndexRedirect to="website" />
              <Route name="Website Template" breadcrumbName="Websites" path="website" component={PubWebTemplates} />
              <Route name="Email Template" breadcrumbName="Email" path="email" component={PubWebEmailTemplate} />
            </Route> */}
            <Route name="Terms Of Service" breadcrumbName="Terms Of Service" path="tos" component={PubTermsOfService} />
          </Route>
        </Route>
      </Route>
    </Route>

    <Route name="Advertiser" breadcrumbIgnore path="advertiser">
      <IndexRoute component={LoginPage} />
      <Route path="login" component={LoginPage} />
      <Route path="forgotpassword" component={ForgotPassword} />
      <Route path="password/:token/edit" component={ResetPassword} />
      <Route name="Advertiser Home" path="home" breadcrumbIgnore component={UserIsAuthenticated(UserIsAdvertiser(AdvertiserContainer))}>
        <IndexRedirect to="accounts" />
        <Route name="User Settings" path="settings" component={AdvSettings} />
        <Route name="Accounts" path="accounts">
          <IndexRoute breadcrumbIgnore component={AdvAccIndex} />
          <Route name="Account" path=":accountSlug" breadcrumbName=":accountName" component={AdvertiserAccountContainer}>
            <IndexRedirect to="dashboard" />
            <Route name="Dashboard" breadcrumbName="Dashboard" path="dashboard" component={AdvAccDashboard} />
            <Route name="Invoices" breadcrumbName="Invoices" path="invoices" component={UserIsNotCustomDash(AdvAccInvoicesIndex)} />
            <Route name="Cards" breadcrumbName="Payment Options" path="cards" component={UserIsNotCustomDash(AdvAccCardsIndex)} />
            <Route name="Pixel" breadcrumbName="Pixel" path="pixel" component={AdvAccPixel} />
            <Route name="Account Info" breadcrumbName="Account Info" path="info" component={AdvAccEdit} />
            <Route name="Job Inventory" breadcrumbName="Job Inventory" path="job_inventory" component={AdvAccJobs} />
            <Route name="Campaigns" breadcrumbName="Campaigns" path="campaigns">
              <IndexRoute breadcrumbIgnore component={UserIsNotCustomDash(AdvCampIndex)} />
              <Route name="New Campaign" breadcrumbName="New Campaign" path="new" component={UserIsNotCustomDash(AdvCampNew)} />
              <Route name="Campaign Wizard" breadcrumbName="Campaign Wizard" path="wizard" component={UserIsNotCustomDash(AdvCampWizard)} />
              <Route name="Manage Campaign" breadcrumbName="Manage Campaign" path=":campaignId" component={UserIsNotCustomDash(AdvCampShow)} />
            </Route>
            <Route name="Ads" breadcrumbName="Ads" path="ads">
              <IndexRoute breadcrumbIgnore component={UserIsNotCustomDash(AdvAdIndex)} />
              <Route name="New Ad" breadcrumbName="New Ad" path="new" component={UserIsNotCustomDash(AdvAdNew)} />
            </Route>
            <Route name="Terms of Service" breadcrumbName="Terms Of Service" path="tos" component={AdvTermsOfService} />
          </Route>
        </Route>
      </Route>
    </Route>

    <Route name="Admin" path="admin" component={UserIsAuthenticated(UserIsAdmin(AdminContainer))}>
      <IndexRedirect to="publisher" />
      <Route name="Publisher" path="publisher" component={UserIsAuthenticated(UserIsAdmin(AdminPublisherIndex))} />
      <Route name="Advertiser" path="advertiser" component={UserIsAuthenticated(UserIsAdmin(AdminAdvertisersIndex))} />
      <Route name="Websites" path="websites" component={UserIsAuthenticated(UserIsAdmin(AdminWebsiteIndex))} />
      <Route name="Statement" path="statement" component={UserIsAuthenticated(UserIsAdmin(AdminStatementIndex))} />
      <Route name="Ad" path="ad" component={UserIsAuthenticated(UserIsAdmin(AdminAdsIndex))} />
      <Route name="Campaign" path="campaign" component={UserIsAuthenticated(UserIsAdmin(AdminCampaignsIndex))} />
      <Route name="Sales Rep" path="sales_rep" component={UserIsAuthenticated(UserIsAdmin(AdminSalesRepsIndex))} />
      <Route name="Account" path="account" component={UserIsAuthenticated(UserIsAdmin(AdminAccountsIndex))} />
      <Route name="Email Alert Campaign" path="email_alerts/campaign" component={UserIsAuthenticated(UserIsAdmin(AdminEmailAlertsIndex))} />
      <Route name="Feed Log" path="feed_logs" component={UserIsAuthenticated(UserIsAdmin(AdminFeedLogsIndex))} />
      <Route name="Connection Reports" path="connection_reports" component={UserIsAuthenticated(UserIsAdmin(AdminConnectionReportsIndex))} />
      <Route breadcrumbName="Reports" name="Reports" path="reports">
        <IndexRedirect to="publisher" />
        <Route name="Publisher" path="publisher" component={UserIsAuthenticated(UserIsAdmin(AdminReportsPublisherIndex))} />
        <Route name="Advertiser" path="advertiser" component={UserIsAuthenticated(UserIsAdmin(AdminReportsAdvertiserIndex))} />
      </Route>
    </Route>
    <Redirect from="*" to="/404" />
  </Route>
);
